import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../../homepage/header-banner/TopNavButton";
import Kafka from "../../homepage/header-banner/Kafka";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../container/Sidebar/Sidebar";
import "../../container/Sidebar/sidebar.css";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard";
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute";
import CardBox from "../../container/Box/Components/CardBox";
import CloudConsultCp from "../../homepage/consult/cloudconsult-cp";
import "../../Style/typo.css";
import Cloudconsult2 from "../../homepage/consult/cloudconsult-2";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";
import DividerComponent from "../../container/Divider/divider";
import styled from "styled-components";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloudEN from "../../container/Banner/banner-privateCloud-en";
import Cloudconsult2EN from "../../homepage/consult/cloudconsult-2-en";
import SidebarEN from "../../container/Sidebar/Sidebar-en";
import HeaderEn from "../../detailpageVN/Page/component/headeren";
import FooterEn from "../../detailpageVN/Page/component/footeren";

const Sysfont = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
`;

function ClusterkafkaEN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "Private Kafka Cluster - Private Kubernetes - Private Cloud";
    }, []);
    return (
        <Sysfont className="App">
            <HeaderEn />
            <BannerPrivateCloudEN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarEN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for Kafka Engine")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Cloud-Based Event and Data Streaming Platform</p>",
                                    `<p class='typo-14'>This is a Kubernetes-based data streaming platform built on the Apache Kafka engine.</p>
                                <p class='typo-14'>Supports integration with virtual servers (instances) on the Hanbiro Cloud platform to build scalable Kafka clusters.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Data streaming platform that supports sharding and replication in Kubernetes clusters</p>",
                                    `<p class='typo-14'>Implements a zero-downtime system that maintains service during container (POD) failures by switching to standby containers./p>
                                <p class='typo-14'>Kafka supports horizontal scaling through sharding, dividing topic logs across distributed containers for load balancing.</p>
                                <p class='typo-14'>It is the real-time data streaming engine operated across all Hanbiro software solutions.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>High-performance Persistent Volume operation with optimized I/O performance</p>",
                                    `<p class='typo-14'>Runs on SSD-based PV volumes with 3 replicas (containers/PODs) forming one service unit.</p>
                                <p class='typo-14'>Even if hardware failures occur on Kubernetes worker nodes, service continues on replica containers (PODs) on other nodes.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Automated reallocation of containers (PODs) during hardware failures to ensure zero downtime</p>",
                                    `<p class='typo-14'>Each Kafka container (POD) consists of 3 replica nodes per service.</p>
                                <p class='typo-14'>The replicas are distributed across multiple Kubernetes worker nodes for load balancing and resilience.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Automatic scale-Out for container expansion and load balancing</p>",
                                    `<p class='typo-14'>The system periodically adjusts (scales up or down) the number of containers (PODs) based on CPU utilization, memory usage, or other custom metrics to ensure optimal performance.</p>
                                <p class='typo-14'>This allows the service to operate without the need to acquire additional hardware resources for scaling.</p>
                                <p class='typo-14'>It is a cluster solution that efficiently manages load balancing and minimizes costs.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>
                                {Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-kafka/kafka_cluster.svg")}
                            </MuiGrid>
                            <DividerComponent />
                        </MuiGrid>

                        {/* <Kafka /> */}
                        <Cloudconsult2EN />
                    </Col>
                </Row>
            </Container>

            <FooterEn />
        </Sysfont>
    );
}

const MuiGrid = styled.div`
    padding: 0px;
`;

export default ClusterkafkaEN;
